import {
  PAGE_ID_RUNTIME_ERROR,
  PAGE_STATUS_ENTERING,
  PAGE_STATUS_ACTIVE,
  PAGE_STATUS_LEAVING,
  PAGE_STATUS_INACTIVE,
  PAGE_ID_FINISHED,
} from '~/utils/constants';

import
* as actions
  from '../actions/course.actions';
import {getPages} from '../selectors/course.selectors';


export const initialState = {
  data: undefined,
  userData: {},
  id: undefined,
  isFetching: true,
  collectedData: {},
  winningStreak: 0,
  pagesInitTimestamps: {},
  isMeeting: 0,
  courseType: 0,
  events: [],
  files: [],
  track: {
    status: false,
    data: undefined,
    activeCourse: 0,
  },
  sco: null,
  members: {
    status: 'NOT-INIT',
    data: [],
  },
  nextPageLoading: false,
  pageHistory: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
  case actions.SET_ACTIVE_PAGE_ID: {
    const pages = getPages({course: state});
    const activePage = pages.find(p => p.id === action.payload);

    if (
      activePage
        && activePage.templateTypeId === 'PICTURESLIDES-TEXT'
        && activePage.pictureslides?.slides.length > 0
    ) {
      return {
        ...state,
        data: {
          ...state.data,
          activePageId: action.payload,
          activeSlideId: activePage.pictureslides?.slides?.[0]?.id,
        },
        showPage: 1,
      };
    }

    return {
      ...state,
      data: {
        ...state.data,
        activePageId: action.payload,
      },
      showPage: 1,
    };
  }
  case actions.SET_COURSE_TYPE: {
    const {courseType, sco} = action.payload;

    return {
      ...state,
      courseType,
      sco,
    };
  }
  case actions.SET_MEETING_TYPE: {
    const {meetingType} = action.payload;

    return {
      ...state,
      isMeeting: meetingType,
    };
  }
  case actions.FETCH_COURSE_DATA_REQUEST: {
    return {
      ...state,
      data: undefined,
      isFetching: true,
    };
  }
  case actions.FETCH_TRACK_DATA_SUCCESS: {
    return {
      ...state,
      track: {
        ...state.track,
        data: action.payload,
      },
    };
  }
  case actions.FETCH_COURSE_DATA_SUCCESS: {
    return {
      ...state,
      isFetching: false,
      data: action.payload,
    };
  }
  case actions.ADD_MEMBER: {
    const {id, info} = action.payload;
    const newData = state.members.data;

    newData.push({id, info});

    return {
      ...state,
      members: {data: newData},
    };
  }
  case actions.REMOVE_MEMBER: {
    const removeData = state.members.data;

    return {
      ...state,
      members: {data: removeData.filter(m => m.id !== action.payload.id)},
    };
  }
  case actions.FETCH_COURSE_DATA_FAILURE: {
    return {
      ...state,
      isFetching: false,
      data: undefined,
    };
  }

  case actions.COURSE_SET_COLLECTED_DATA: {
    return {
      ...state,
      collectedData: action.payload,
    };
  }
  case actions.COURSE_SET_PAGE_COMPONENT_COLLECTED_DATA: {
    return {
      ...state,
      collectedData: {
        ...state.collectedData,
        [action.payload.pageId]: {
          ...state.collectedData[action.payload.pageId],
          [action.payload.componentDataKey]: action.payload.collectedData,
        },
      },
    };
  }
  case actions.COURSE_SET_USER_DATA: {
    return {
      ...state,
      data: {
        ...state.data,
        phceId: action.payload.phce,
      },
      userData: action.payload,
    };
  }
  case actions.COURSE_LEAVE_PAGE_REQUEST: {
    const pages = getPages({course: state});

    return {
      ...state,
      data: {
        ...state.data,
        pages: pages.map(page =>
          page.id === state.data.activePageId
            ? {
              ...page,
              status: PAGE_STATUS_LEAVING,
            }
            : page),
      },
    };
  }
  case actions.COURSE_LEAVE_PAGE_SUCCESS: {
    const pages = getPages({course: state});

    return {
      ...state,
      data: {
        ...state.data,
        result:
            action.payload && action.payload.result ? action.payload.result : state.data.result,
        pages: pages.map(page =>
          page.id === state.data.activePageId
            ? {
              ...page,
              status: PAGE_STATUS_INACTIVE,
            }
            : page),
        phceId:
            action.payload && action.payload.phceId ? action.payload.phceId : state.data.phceId,
      },
    };
  }
  case actions.COURSE_LEAVE_PAGE_FAILURE: {
    const pages = getPages({course: state});

    return {
      ...state,
      data: {
        ...state.data,
        activePageId: PAGE_ID_RUNTIME_ERROR,
        pages: pages.map(page =>
          page.id === state.data.activePageId
            ? {
              ...page,
              status: PAGE_STATUS_INACTIVE,
            }
            : page),
        phceId:
            action.payload && action.payload.phceId ? action.payload.phceId : state.data.phceId,
      },
    };
  }
  case actions.SET_ACTIVE_SLIDE_ID: {
    return {
      ...state,
      data: {
        ...state.data,
        activeSlideId: action.payload,
      },
    };
  }

  case actions.COURSE_EVENT: {
    return {
      ...state,
      events: [...state.events, action.payload],
    };
  }
  case actions.COURSE_LAST_PAGE_REQUEST: {
    return {
      ...state,
      data: {
        ...state.data,
        activePageId: PAGE_ID_FINISHED,
      },
      track: {
        ...state.track,
        activeCourse: 0,
      },
    };
  }
  case actions.SET_ACTIVE_COURSE: {
    return {
      ...state,
      track: {
        ...state.track,
        activeCourse: action.payload.activeCourse,
      },
    };
  }

  case actions.COURSE_ENTER_PAGE_REQUEST: {
    const pages = getPages({course: state});
    const targetPage = pages.find(({id}) => id === action.payload.id);
    const slides = targetPage?.pictureslides?.slides;

    return {
      ...state,
      data: {
        ...state.data,
        activePageId: action.payload.id,
        activeSlideId: slides && slides[0]?.id,
        pages: pages.map(page =>
          page.id === action.payload.id
            ? {
              ...page,
              status: PAGE_STATUS_ENTERING,
            }
            : page),
      },
      pagesInitTimestamps: {
        ...state.pagesInitTimestamps,
        [state.data.activePageId]: null,
      },
    };
  }
  case actions.COURSE_ENTER_PAGE_SUCCESS: {
    const pages = getPages({course: state});

    return action.payload && action.payload.data && action.payload.data.result
      ? {
        /*
        * SHOULD GET RESULT ON THE LAST PAGE STORE IT.
        * */
        ...state,
        data: {
          ...state.data,
          pages: pages.map(page =>
            page.id === state.data.activePageId
              ? {
                ...page,
                status: PAGE_STATUS_ACTIVE,
              }
              : page),
          phceId:
            action.payload && action.payload.phceId ? action.payload.phceId : state.data.phceId,
        },
        pagesInitTimestamps: {
          ...state.pagesInitTimestamps,
          [state.data.activePageId]: Date.now(),
        },
      }
      : {
        ...state,
        data: {
          ...state.data,
          pages: pages.map(page =>
            page.id === state.data.activePageId
              ? {
                ...page,
                status: PAGE_STATUS_ACTIVE,
              }
              : page),
          phceId:
              action.payload && action.payload.phceId ? action.payload.phceId : state.data.phceId,
        },
        pagesInitTimestamps: {
          ...state.pagesInitTimestamps,
          [state.data.activePageId]: Date.now(),
        },
      };
  }
  case actions.COURSE_ENTER_PAGE_FAILURE: {
    const pages = getPages({course: state});

    return {
      ...state,
      data: {
        ...state.data,
        activePageId: PAGE_ID_RUNTIME_ERROR,
        pages: pages.map(page =>
          page.id === state.data.activePageId
            ? {
              ...page,
              status: PAGE_STATUS_INACTIVE,
            }
            : page),
        phceId:
            action.payload && action.payload.phceId ? action.payload.phceId : state.data.phceId,
      },
    };
  }
  case actions.ENTER_SPEED_COURSE_PAGE: {
    const pages = getPages({course: state});

    return {
      ...state,
      data: {
        ...state.data,
        activePageId: action.payload.pageId,
        pages: pages.map(page =>
          page.id === action.payload
            ? {
              ...page,
              status: PAGE_STATUS_ENTERING,
            }
            : page),
      },
      pagesInitTimestamps: {
        ...state.pagesInitTimestamps,
        [action.payload.pageId]: Date.now(),
      },
    };
  }
  case actions.COURSE_INCREMENT_WINNING_STREAK: {
    return {
      ...state,
      winningStreak: state.data.winningStreak + 1,
    };
  }

  case actions.COURSE_DROP_WINNING_STREAK: {
    return {
      ...state,
      winningStreak: 0,
    };
  }

  case actions.RUNTIME_ERROR_CATCH: {
    return {
      ...state,
      data: {
        ...state.data,
        activePageId: PAGE_ID_RUNTIME_ERROR,
      },
    };
  }

  case actions.COURSE_ON_CONTINUE_CLICK: {
    return {
      ...state,
      nextPageLoading: true,
    };
  }

  case actions.NEXT_PAGE_LOADED: {
    return {
      ...state,
      nextPageLoading: !action.payload,
    };
  }

  case actions.ADD_PAGE_HISTORY: {
    return {
      ...state,
      pageHistory: [...state.pageHistory || [], action.payload],
    };
  }

  default: {
    return state;
  }
  }
};
